/**
 * Enum containing storage keys used by the AdminAuthService
 * for secure tenant information storage
 */
export enum AdminAuthStorageKeys {
  /**
   * Key used for storing encrypted admin tenant information in localStorage
   */
  ADMIN_TENANT = '_adminTenant',

  /**
   * Key used for storing the session encryption key in sessionStorage
   */
  SESSION_KEY = '_sk',
}
